<template>
  <div class="not-auth-layout">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "NotAuthLayout"
  }
</script>

<style scoped>

</style>
